import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ScrollToBottomButton from '../components/ui/ScrollToBottomButton';
import heroImage from '../assets/1.webp';
import heroImageMobile from '../assets/2.webp';

const TermsAndConditions = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const terms = [
    {
      title: '1. Check-in / Check-out',
      points: [
        'Check-in time: 1:00 PM',
        'Check-out time: 11:00 AM',
        'Early check-in and late check-out are subject to availability and may be chargeable.',
      ],
    },
    {
      title: '2. Booking Confirmation & Advance Payment',
      points: [
        'All reservations must be confirmed by paying an advance amount equivalent to one night’s stay.',
        'The advance payment must be completed within 48 hours of receiving the booking confirmation.',
        'Booking is confirmed only after receipt of advance payment.',
      ],
    },
    {
      title: '3. Cancellation Policy',
      points: [
        'Cancellation within 48 hours prior to check-in: No refund.',
        'Cancellation between 14 days and 48 hours prior to check-in: 50% of advance forfeited.',
        'Cancellation 14 days or more prior to check-in: Full refund after 10% deduction towards administrative charges.',
      ],
    },
    {
      title: '4. Room Rates & Taxes',
      points: [
        'All tariffs are per room per night.',
        'Rates are subject to applicable government taxes.',
        'Extra bed / extra person charges apply as per hotel policy.',
      ],
    },
    {
      title: '5. Occupancy Policy',
      points: [
        'Room occupancy must not exceed the maximum capacity mentioned at the time of booking.',
        'Unregistered guests are not allowed to stay overnight.',
      ],
    },
    {
      title: '6. Children Policy',
      points: [
        'Children above the age limit prescribed by the hotel will be charged as extra occupants.',
      ],
    },
    {
      title: '7. Identity Proof',
      points: [
        'All guests must present a valid government-issued photo ID at the time of check-in.',
        'Local ID may be accepted as per hotel policy.',
      ],
    },
    {
      title: '8. Hotel Conduct & Property Rules',
      points: [
        'Guests are requested to maintain decorum and respect hotel property.',
        'Any damage to hotel property will be charged to the guest.',
        'The hotel reserves the right to refuse service in case of misconduct.',
      ],
    },
    {
      title: '9. Heating & Seasonal Facilities',
      points: [
        'Heating facilities are provided subject to weather conditions and hotel policy and may be chargeable.',
      ],
    },
    {
      title: '10. Restaurant & Meals',
      points: [
        'The hotel operates on E.P. Plan (Room Only).',
        'Meals are not included in the room tariff.',
      ],
    },
    {
      title: '11. Views & Room Allocation',
      points: [
        'All rooms have views (mall road, garden, or hill-facing).',
        'View preference is subject to availability and cannot be guaranteed.',
      ],
    },
    {
      title: '12. Force Majeure',
      points: [
        'The hotel shall not be liable for delays or cancellations due to natural calamities, government restrictions, or circumstances beyond control.',
      ],
    },
    {
      title: '13. Management Rights',
      points: [
        'Management reserves the right to amend or modify these terms and conditions without prior notice.',
      ],
    },
  ];

  return (
    <>
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{ backgroundImage: `url(${isMobile ? heroImageMobile : heroImage})` }}
        data-aos="fade-in"
      >
        <div className="absolute inset-0 bg-black opacity-60"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight" data-aos="fade-up">Terms and Conditions</h1>
          <p className="mt-4 text-lg text-gray-300" data-aos="fade-up" data-aos-delay="100">Your agreement with Pineridge Hotel</p>
        </div>
        <ScrollToBottomButton targetId="terms-content" />
      </section>

      <main id="terms-content" className="bg-gray-50 py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12" data-aos="fade-up">
            <h2 className="text-5xl font-semibold text-dark-green">Welcome to Pineridge Hotel</h2>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              We are delighted to have you as our guest. To ensure clarity and transparency, please read the following terms and conditions carefully. By accessing our website or booking a stay with us, you agree to comply with the terms outlined below.
            </p>
          </div>

          <div className="space-y-8">
            {terms.map((term, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-beige" data-aos="fade-up">
                <h3 className="text-xl font-semibold text-dark-green mb-4">{term.title}</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  {term.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          

          <div className="mt-12 text-center" data-aos="fade-up">
            <p className="text-lg text-gray-600">
              Thank you for choosing Pineridge Hotel. We appreciate your cooperation and look forward to hosting you.
            </p>
          </div>
        </div>
      </main>
    </>
  );
};

export default TermsAndConditions;